import { LOCAL_STORAGE_KEY } from './config';
import { CustomerDataType } from '../types';

export const getUserData = (): CustomerDataType | null => {
  const localData = window.localStorage.getItem(LOCAL_STORAGE_KEY);

  if (!localData) {
    return null;
  }

  return JSON.parse(localData)?.customer;
};
